import React, { useContext } from 'react';
import DateTimeDisplay from './DateTimeDisplay';
import { useCountdown } from '../hooks/useCountdown';
import CountdownContext from '../context/CountdownContext';

interface ShowCounterProps {
  hours: number;
  minutes: number;
  seconds: number;
}

const ShowCounter: React.FC<ShowCounterProps> = ({ hours, minutes, seconds }) => (
  <div className="show-counter">
    <div className="countdown-link">
      <DateTimeDisplay value={hours} type={''} isDanger={false} />
      <p>:</p>
      <DateTimeDisplay value={minutes} type={''} isDanger={false} />
      <p>:</p>
      <DateTimeDisplay value={seconds} type={''} isDanger={false} />
    </div>
  </div>
);

interface CountdownTimerProps {
  onStart: () => void;
  isDisabled?: boolean;
  disabledLabel?: string;
  forceComplete?: boolean;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({
  onStart,
  isDisabled = false,
  disabledLabel = 'CAMPAIGN DISABLED',
  forceComplete = false,
}) => {
  const { targetDate } = useContext(CountdownContext);
  const [days, hours, minutes, seconds] = useCountdown(targetDate);

  if (forceComplete || days + hours + minutes + seconds <= 0) {
    return (
      <div>
        <div
          className={`button flex justify-center items-center h-16 border-2 rounded-lg ${
            isDisabled
              ? 'bg-black bg-opacity-10 text-gray-400 border-gray-500 cursor-not-allowed opacity-70'
              : 'bg-black bg-opacity-0 text-yellow-500 border-yellow-500 cursor-pointer'
          }`}
          onClick={isDisabled ? undefined : onStart}
          aria-disabled={isDisabled}
        >
          {isDisabled ? disabledLabel : 'START NOW!'}
        </div>
      </div>
    );
  }

  return <ShowCounter hours={hours} minutes={minutes} seconds={seconds} />;
};

export default CountdownTimer;
